module.exports = __webpack_public_path__ + "static/media/carros.9a26fa39.png";